import React from "react"
import axios from 'axios';
import "../css/shared_css/footer.css"
import { useNavigate } from "react-router-dom"
import { backend_url } from "../App.js"

function Footer() {
    const navigate = useNavigate();

    // Opens a new tab with the CFL's Instagram/LinkedIn page
  const showIGpage = () => {
    window.open("https://www.instagram.com/lucenterforfinancialliteracy/?_ga=2.268035211.488967955.1669654119-816072560.1565226602", "_blank");
  };

  const showLIpage = () => {
    window.open("https://www.linkedin.com/company/center-for-financial-literacy-liberty-university/?viewAsMember=true", "_blank");
  };

  // Deletes the given user's account and associated data
  let deleteAccount = async () => {
    let uid = sessionStorage.getItem('userID');
    try {
        // Delete user's expense data
        const response = await axios.post(backend_url + 'deleteRowsOfUser', { 
            userID: uid
        });
        
        // Delete the user itself
        response = await axios.post(backend_url + 'deleteUser', {
            userID: uid
        })
    }
    catch (error) {
        console.error(error);
    }
    // Navigate back to the login page
    navigate("/")
    }
    return (
        <>
            
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
            <link
                href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;600;700&display=swap"
                rel="stylesheet"
            />
            <link
                rel="stylesheet"
                href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.min.css"
            />
            
            <section className="footer">
                <div className="icons">
                    <i className="fa-brands fa-instagram" onClick={showIGpage}></i>
                    <i className="fa-brands fa-linkedin" onClick={showLIpage}></i>
                </div>
                <p>Made with <i className="fas fa-heart"></i> by CFL Team</p>
                <input class="button" type="button" value="Delete Account" onClick={deleteAccount}/>
            </section>
        </>
    )
};

export default Footer